import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, MessageSquare } from 'lucide-react';

const LOGO = process.env.REACT_APP_LOGO_URL || '/logo.png';

export default function Footer() {
  return (
    <footer className="bg-[#080808] border-t border-[#151515] mt-16 relative" data-testid="footer">
      {/* Subtle top accent */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-rm-red/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <img src={LOGO} alt="RobloxMart" className="h-8 w-8 object-contain" />
              <span className="font-rajdhani font-bold text-base tracking-wider">ROBLOX<span className="text-rm-red">MART</span></span>
            </div>
            <p className="text-zinc-600 text-xs leading-relaxed mb-4">
              The premier Roblox items marketplace. Connect with trusted sellers and buyers across all popular games.
            </p>
            <a href={process.env.REACT_APP_DISCORD_SUPPORT || 'https://discord.gg/robloxmart'} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-[#7289da] hover:text-[#9aa7ff] transition-colors">
              <MessageSquare size={12} /> Join our Discord
            </a>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-rajdhani font-bold text-[10px] uppercase tracking-[0.2em] text-zinc-600 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/browse', label: 'Browse Listings' },
                { to: '/auth', label: 'Login / Register' },
                { to: '/feedback', label: 'Support & Feedback' },
                { to: '/donate', label: 'Support Us' },
                { to: '/tos', label: 'Terms of Service' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-xs text-zinc-500 hover:text-white transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Disclaimer */}
          <div>
            <h4 className="font-rajdhani font-bold text-[10px] uppercase tracking-[0.2em] text-zinc-600 mb-4">Disclaimer</h4>
            <div className="flex gap-2.5">
              <ShieldAlert size={13} className="text-rm-red shrink-0 mt-0.5" />
              <p className="text-xs text-zinc-600 leading-relaxed">
                RobloxMart is not affiliated with Roblox Corporation and does not process payments. We only connect buyers and sellers. All trades are completed outside this platform.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-[#151515] mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-[11px] text-zinc-700">© {new Date().getFullYear()} RobloxMart. Not affiliated with Roblox Corporation.</p>
          <p className="text-[11px] text-zinc-800 font-rajdhani font-semibold tracking-widest">ROBLOXMART.STORE</p>
        </div>
      </div>
    </footer>
  );
}
